import React, { useState, useEffect, useRef } from "react";
import jaqkCoin from "../../assets/images/coin.svg";
import coins from "../../assets/images/loyalty/coins.svg";
import wallet from "../../assets/images/loyalty/wallet.svg";
import AllStar from "../../assets/images/loyalty/thrill.webp";
import Beginner from "../../assets/images/loyalty/dash.webp";
import vip from "../../assets/images/loyalty/boss.webp";
import Pro from "../../assets/images/loyalty/surge.webp";
import Rookie from "../../assets/images/loyalty/sprint.webp";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoyaltyConfig from "../../assets/loyaltyPointsConfig.json";
import {
  coinsHistory,
  getUserDetails,
  getUserLoyalty,
  setErrorMessage,
} from "../signIn/cl_SignInSlice";
import CircularProgressBar from "./CircularProgress";
import {  setShowRedeemPopUp } from "../home/cl_LoyalltyCoins";
import { RedeemModal } from "./RedeemModal";

const FasFasCoins = () => {
  const topRef = useRef(null);
  const [burnCoins, setBurnCoins] = useState("");
  const [minMaxValues, setMinMaxValue] = useState("");
  const [perMaxValues, setPerMinMaxValue] = useState("");
  const { errorMessage, isLoading } = useSelector((state) => state.signIn);
  const { showRedeemPopUp } = useSelector(
    (state) => state?.coinsHistory
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setErrorMessage(""));
    topRef.current.scrollIntoView(true);
  }, []);
  const [isHovering, setIsHovering] = useState(true);
  const { userDetails, userLoyalty, lifeTimeBurns, lifeTimeCashBack } =
    useSelector((state) => state?.signIn);
  const balenceCoins = userLoyalty?.coins > 0 ? userLoyalty?.coins : 0;
  const { coinsHistoryData } = useSelector((state) => state.coinsHistory);
  const levelIndex = parseInt(userLoyalty?.level?.replace("level", ""));
  const minBurnCoins =
    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[levelIndex]
      ?.minBurnCoins;
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getUserDetails());
  }, []);
  useEffect(() => {
    if (userDetails?.userId) {
      dispatch(coinsHistory(userDetails?.userId));
      dispatch(getUserLoyalty(userDetails?.userId));
    }
  }, [userDetails?.userId]);
  function handleMouseOut() {
    setIsHovering(true);
  }
  const redeemCoin = () => {
    let errorMsg = "";

    if (!burnCoins || burnCoins > userLoyalty.coins) {
      errorMsg = "Please enter a valid value to redeem FasFas coins";
    } else {
      LoyaltyConfig.loyaltyPointsConfig[1]?.loyaltyLevels.forEach((data) => {
        if (userLoyalty.level === data.level) {
          if (data?.level === "level4") {
            setMinMaxValue(
              `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${
                userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0
              } Coins)`
            );
          } else {
            setMinMaxValue(
              `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${Number(data.maxBurnCoins).toLocaleString()} Coins)`
            );
          }
          if (data.level === "level4") {
            if (burnCoins < data.minBurnCoins) {
              errorMsg = `Please enter a value greater than ${
                data.minBurnCoins - 1
              } coins`;
            } else if (burnCoins > userLoyalty?.coins) {
              errorMsg = `Please enter a value less than ${
                userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0
              } coins`;
            }
          } else if (burnCoins < data.minBurnCoins) {
            errorMsg = `Please enter a value greater than ${
              data.minBurnCoins - 1
            } coins`;
          } else if (burnCoins > data.maxBurnCoins) {
            errorMsg = `Please enter a value less than ${
              data.maxBurnCoins + 1
            } coins`;
          }
        }
      });
    }
    if (errorMsg) {
      dispatch(setShowRedeemPopUp(false));
    } else {
      dispatch(setShowRedeemPopUp(true));
    }
    dispatch(setErrorMessage(errorMsg));

  };

  useEffect(() => {
    LoyaltyConfig.loyaltyPointsConfig[1]?.loyaltyLevels.forEach((data) => {
      if (userLoyalty?.level === data?.level) {
        if (data?.level === "level4") {
          setMinMaxValue(
            `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${
              userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0
            } Coins)`
          );
        } else {
          setMinMaxValue(
            `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${Number(data.maxBurnCoins).toLocaleString()} Coins)`
          );
        }
        setPerMinMaxValue(
          data?.levelCutoff ? data?.levelCutoff : data?.levelEntry
        );
      }
    });
  }, [userLoyalty?.level, userLoyalty?.coins]);

  const handleChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[+-]+/, "");
    const re = /^[0-9]*$/;
    if (re.test(inputValue)) {
      setBurnCoins(inputValue);
    }
    dispatch(setErrorMessage(""));
  };
  const handleKeyDown = (e) => {
    if (e.key === "+" || e.key === "-") {
      e.preventDefault();
    }
  };

  return (
    <React.Fragment>
      <div className="SB-page-content" ref={topRef}>
        <div className="SB-myAccountSection-container SB-coins">
          <div className="SB-pageHeader">
            <div className="SB-pageHeader-title">FasFas Coins</div>
          </div>
          <div className="SB-content">
            <div className="SB-coinsStrip">
              <div className="marquee-container">
                <ul
                  className={isHovering ? "marquee" : ""}
                  // onMouseOver={handleMouseOver}
                  onMouseOut={handleMouseOut}
                >
                  <li>Play Games</li>
                  <li>Earn FasFas Coins</li>
                  <li>Get Instant Cash</li>
                </ul>
              </div>
            </div>
            <div className="SB-myAccount-sectionBox SB-totalCoins">
              <div className="SB-myAccount-sectionBox_content">
                <div className="SB-coinsItem">
                  <div className="SB-coinsItem-label">FasFas Coins</div>
                  <div className="SB-coinsItem-value">
                    <img src={jaqkCoin} alt="jaqk-coin" />
                    <span>
                      {userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0}
                    </span>
                  </div>
                </div>
                <div className="SB-coinsItem-image">
                  <img src={coins} alt="coins" />
                </div>
              </div>
            </div>
            <div className="SB-myAccount-sectionBox SB-coinsProgress">
              <div className="SB-myAccount-sectionBox_content">
                <div className="SB-coinsProgressbar">
                  <CircularProgressBar
                    value={balenceCoins}
                    maxValue={
                      perMaxValues < balenceCoins ? balenceCoins : perMaxValues
                    }
                    progressColor="#007bff"
                  />
                </div>

                <div className="SB-coinsProgress-content">
                  <p>Minimum {Number(minBurnCoins).toLocaleString()} FasFas Coins needed to redeem.</p>
                  <div className="SB-btnContainer">
                    <Link to={"/"}>
                      <button className="btn SB-btnSecondary active SB-btnplayGames">
                        Play Games
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {userLoyalty?.coins ? (
              Math.floor(userLoyalty?.coins) >= minBurnCoins ? (
                <div className="SB-myAccount-sectionBox SB-burnCoins">
                  <div className="SB-myAccount-sectionBox_content">
                    <p>
                      You can redeem FasFas Coins now for an exchange of
                      surprise Instant Cash
                    </p>
                    <div className="SB-form-group">
                      <div className="SB-form-label">
                        <span>Enter FasFas Coins to redeem</span>
                        <span className="SB-coinsMinMax">{minMaxValues}</span>
                      </div>
                      <div className="SB-form-control">
                        <input
                          type="text"
                          value={burnCoins}
                          onChange={handleChange}
                          onKeyDown={handleKeyDown}
                          placeholder="Enter Coins Here"
                          maxLength={10}
                        />
                      </div>
                      <div className="SB-form-errorMsg">
                        {errorMessage && <span>{errorMessage}</span>}
                      </div>
                    </div>
                    <div className="SB-btnContainer">
                      <button
                        className="btn SB-btnSecondary active SB-btncoinsBurnNow"
                        data-toggle="modal"
                        data-target="SB-burnNowCoins-modal"
                        onClick={redeemCoin}
                      >
                        Redeem Now
                      </button>
                    </div>

                    <p>
                      You will get Instant Cashback credited to your wallet
                      immediately
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )
            ) : (
              ""
            )}
            {showRedeemPopUp && (
              <RedeemModal coins={burnCoins} setBurnCoins={setBurnCoins} />
            )}
            <div className="SB-myAccount-sectionBox SB-coinsHistory-details">
              <div className="SB-myAccount-sectionBox_content">
                <div className="SB-coinsItem-group">
                  <div className="SB-coinsItem">
                    <div className="SB-coinsItem-label">Lifetime Earns</div>
                    <div className="SB-coinsItem-value">
                      <img src={jaqkCoin} alt="jaqk-coin" />
                      <span>
                        {userLoyalty?.lifeTimeCoins
                          ? Math.floor(userLoyalty?.lifeTimeCoins).toLocaleString()
                          : 0}
                      </span>
                    </div>
                  </div>
                  <div className="SB-coinsItem">
                    <div className="SB-coinsItem-label">Lifetime Redeem</div>
                    <div className="SB-coinsItem-value">
                      <img src={jaqkCoin} alt="jaqk-coin" />
                      <span>
                        {lifeTimeBurns > 0 ? Math.floor(lifeTimeBurns).toLocaleString() : 0}
                      </span>
                    </div>
                  </div>
                  <div className="SB-coinsItem">
                    <div className="SB-coinsItem-label">
                      Lifetime Cashback Earned
                    </div>
                    <div className="SB-coinsItem-value">
                      <img src={wallet} alt="Wallet" />
                      <span>
                        {typeof lifeTimeCashBack === "number"
                          ? lifeTimeCashBack.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                          : 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="SB-btnContainer">
                <button
                  className="btn SB-btnSecondary active SB-btncoinsHistory"
                  onClick={() => navigate("/coins-history")}
                >
                  FasFas Coins History
                </button>
              </div>
            </div>

            <div className="SB-myAccount-sectionBox SB-howToEarnCoins">
              <div className="SB-myAccount-sectionBox_header">
                How to Earn FasFas Coins
              </div>
              <div className="SB-userLevel-table SB-table-scrollable">
                <table>
                  <colgroup>
                    <col />
                    <col
                      className={
                        userLoyalty?.lifeTimeCoins <=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                          .levelCutoff
                          ? "active"
                          : ""
                      }
                    />
                    <col
                      className={
                        userLoyalty?.lifeTimeCoins <=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                            .levelCutoff &&
                        userLoyalty?.lifeTimeCoins >=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                            .levelCutoff
                          ? "active"
                          : ""
                      }
                    />
                    <col
                      className={
                        userLoyalty?.lifeTimeCoins <=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                            .levelCutoff &&
                        userLoyalty?.lifeTimeCoins >=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                            .levelCutoff
                          ? "active"
                          : ""
                      }
                    />
                    <col
                      className={
                        userLoyalty?.lifeTimeCoins <=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                            .levelEntry &&
                        userLoyalty?.lifeTimeCoins >=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                            .levelCutoff
                          ? "active"
                          : ""
                      }
                    />
                    <col
                      className={
                        userLoyalty?.lifeTimeCoins >=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                          .levelEntry
                          ? "active"
                          : ""
                      }
                    />
                  </colgroup>
                  <thead>
                    <tr>
                      <td></td>
                      <td>
                        <img src={Beginner} alt="dash" />
                      </td>
                      <td>
                        <img src={Rookie} alt="sprint" />
                      </td>
                      <td>
                        <img src={Pro} alt="surge" />
                      </td>
                      <td>
                        <img src={AllStar} alt="thrill" />
                      </td>
                      <td>
                        <img src={vip} alt="boss" />
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="SB-tbody-tableHeader">
                      {/* <td>Earn FasFas Coins</td> */}
                    </tr>
                    <tr>
                      <td>Tier Cutoff (coins) </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                            .levelEntry
                        }{" "}
                        -{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                            .levelCutoff
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                            .levelEntry
                        }{" "}
                        -{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                            .levelCutoff
                        }
                      </td>
                      <td>
                        {
                         Number( LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                            .levelEntry).toLocaleString()
                        }{" "}
                        -{" "}
                        {
                          Number(LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                            .levelCutoff).toLocaleString()
                        }
                      </td>
                      <td>
                        {
                          Number(LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                            .levelEntry).toLocaleString()
                        }{" "}
                        -{" "}
                        {
                          Number(LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                            .levelCutoff).toLocaleString()
                        }
                      </td>
                      <td>
                        {
                          Number(LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                            .levelEntry).toLocaleString()
                        }
                        +
                      </td>
                    </tr>
                    <tr>
                      <td> Signup</td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .signup.level0
                        }
                      </td>
                      <td>NA</td>
                      <td>NA</td>
                      <td>NA</td>
                      <td>NA</td>
                    </tr>

                    <tr>
                      <td>1st Deposit</td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .firstdeposit.level0.percent
                        }
                        % upto{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .firstdeposit.level0.max
                        }
                      </td>
                      <td>NA</td>
                      <td>NA</td>
                      <td>NA</td>
                      <td>NA</td>
                    </tr>
                    <tr>
                      <td>2nd Deposit</td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .seconddeposit.level0.percent
                        }
                        % upto{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .seconddeposit.level0.max
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .seconddeposit.level1.percent
                        }
                        % upto{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .seconddeposit.level1.max
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .seconddeposit.level2.percent
                        }
                        % upto{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .seconddeposit.level2.max
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .seconddeposit.level3.percent
                        }
                        % upto{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .seconddeposit.level3.max
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .seconddeposit.level4.percent
                        }
                        % upto{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .seconddeposit.level4.max
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>3rd Deposit</td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .thirddeposit.level0.percent
                        }
                        % upto{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .thirddeposit.level0.max
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .thirddeposit.level1.percent
                        }
                        % upto{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .thirddeposit.level1.max
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .thirddeposit.level2.percent
                        }
                        % upto{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .thirddeposit.level2.max
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .thirddeposit.level3.percent
                        }
                        % upto{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .thirddeposit.level3.max
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .thirddeposit.level4.percent
                        }
                        % upto{" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                            .thirddeposit.level4.max
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>For every 100 KES lost </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyCoins
                            .betlost[0].c1.level0
                        }
                      </td>
                      <td>
                        {" "}
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyCoins
                            .betlost[0].c1.level1
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyCoins
                            .betlost[0].c1.level2
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyCoins
                            .betlost[0].c1.level3
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyCoins
                            .betlost[0].c1.level4
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>Min Redeem Coins</td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                            .minBurnCoins
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                            .minBurnCoins
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                            .minBurnCoins
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                            .minBurnCoins
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                            .minBurnCoins
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>Max Redeem Coins</td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                            .maxBurnCoins
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                            .maxBurnCoins
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                            .maxBurnCoins
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                            .maxBurnCoins
                        }
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                            .maxBurnCoins
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Redemption: Cash</strong>
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyLevels[0]
                            .realCashPercentage
                        }
                        %
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyLevels[1]
                            .realCashPercentage
                        }
                        %
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyLevels[2]
                            .realCashPercentage
                        }
                        %
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyLevels[3]
                            .realCashPercentage
                        }
                        %
                      </td>
                      <td>
                        {
                          LoyaltyConfig.loyaltyPointsConfig[0].loyaltyLevels[4]
                            .realCashPercentage
                        }
                        %
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FasFasCoins;
